import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Link, type GatsbyLinkProps } from 'gatsby';
import type { FC, ReactNode } from 'react';

import { ScrollAnchor } from './scroll-anchor';

type Props = GatsbyLinkProps<unknown> & {
  className?: string;
  children: ReactNode;
};

export const Anchor: FC<Props> = ({
  className,
  to,
  children,
  ['aria-label']: ariaLabel,
  activeClassName = 'current',
  partiallyActive = false,
}) => {
  const isInternal = to?.startsWith('/');
  const isHash = to?.startsWith('#');
  if (isInternal) {
    return (
      <StyledLink
        className={className || ''}
        to={to?.endsWith('/') ? to : `${to}/`}
        aria-label={ariaLabel || ''}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
      >
        {children}
      </StyledLink>
    );
  } else if (isHash) {
    return (
      <StyledScrollAnchor
        className={className || ''}
        to={to}
        aria-label={ariaLabel || ''}
      >
        {children}
      </StyledScrollAnchor>
    );
  } else {
    return (
      <StyledA
        className={className || ''}
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={ariaLabel || ''}
      >
        {children}
      </StyledA>
    );
  }
};

const BaseStyle = css`
  cursor: pointer;
`;

const StyledLink = styled(Link)`
  ${BaseStyle}
`;

const StyledScrollAnchor = styled(ScrollAnchor)`
  ${BaseStyle}
`;

const StyledA = styled.a`
  ${BaseStyle}
`;

export default Anchor;
